import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FilePlus2, ArrowRight, FileText, Loader2 } from "lucide-react";
import { CvShell } from "@/components/cv/CvShell";
import { CvGate } from "@/components/cv/CvGate";
import { useAuth } from "@/context/AuthContext";
import { cvApi } from "@/lib/api";

export default function CvMyCvs() {
  const { user } = useAuth();
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!user) return;
    cvApi.list().then((d) => setItems(d.items || [])).catch(() => setItems([]));
  }, [user]);

  return (
    <CvShell active="moje">
      <div data-testid="cv-my-cvs" className="pb-6">
        <div className="flex items-center justify-between">
          <h1 className="font-display text-2xl font-semibold text-brand-text sm:text-3xl">Moje CV</h1>
          {user && (
            <Link to="/cv/kreator?tryb=nowe" data-testid="cv-my-cvs-create" className="inline-flex items-center gap-2 rounded-button bg-brand-accent px-5 py-2.5 text-sm font-semibold text-brand-on transition-transform hover:-translate-y-0.5">
              Nowe CV <ArrowRight size={16} />
            </Link>
          )}
        </div>
        <p className="mt-2 max-w-2xl text-brand-sec">Twoje zapisane dokumenty i wersje robocze.</p>

        {!user ? (
          <div className="mt-8 max-w-2xl"><CvGate returnTo="/cv/moje" message="Załóż bezpłatne konto, aby zapisywać i wracać do swoich CV." /></div>
        ) : items === null ? (
          <div className="mt-10 flex justify-center"><Loader2 className="animate-spin text-brand-accent" /></div>
        ) : items.length === 0 ? (
          <div className="mt-8 flex flex-col items-center justify-center gap-4 rounded-panel border border-brand-line bg-brand-surface px-6 py-16 text-center" data-testid="cv-my-cvs-empty">
            <FilePlus2 size={34} className="text-brand-line" />
            <p className="text-brand-text">Nie masz jeszcze zapisanych CV.</p>
            <Link to="/cv/kreator?tryb=nowe" className="inline-flex items-center gap-2 rounded-button bg-brand-accent px-5 py-2.5 text-sm font-semibold text-brand-on">Stwórz nowe CV <ArrowRight size={16} /></Link>
          </div>
        ) : (
          <ul className="mt-6 space-y-3" data-testid="cv-my-cvs-list">
            {items.map((it) => (
              <li key={it.id} className="rounded-panel border border-brand-line bg-brand-surface transition-colors hover:border-brand-accent/50">
                <Link to={`/cv/kreator/${it.id}`} data-testid="cv-my-cvs-item" className="flex items-center gap-4 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-card border border-brand-line text-brand-accent"><FileText size={18} /></span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate font-medium text-brand-text">{it.title}</p>
                    <p className="text-[12.5px] text-brand-muted">Zmieniono: {new Date(it.updated_at).toLocaleString("pl-PL")}</p>
                  </div>
                  <span className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ${it.status === "ready" ? "bg-brand-accent/15 text-brand-accent" : "border border-brand-line text-brand-sec"}`}>
                    {it.status === "ready" ? "Gotowe do przygotowania" : "Wersja robocza"}
                  </span>
                  <ArrowRight size={16} className="shrink-0 text-brand-muted" />
                </Link>
                {it.status === "ready" && (
                  <div className="border-t border-brand-line px-4 py-2.5">
                    <Link to={`/cv/szablon/${it.id}`} data-testid="cv-my-cvs-template" className="inline-flex items-center gap-1.5 text-[13px] font-medium text-brand-accent hover:underline">
                      <FileText size={14} /> Szablon ATS i pobieranie (PDF / DOCX)
                    </Link>
                  </div>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </CvShell>
  );
}
